module.exports = __webpack_public_path__ + "static/p11_galloCabeza-6a43c026e3636ae8931b322ce0c1f4b0.png";